import { NgxUiLoaderConfig } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { AppConfigService } from '../core/services/app-config.service';

export function readJsonFile() {
  let appConfig: AppConfigService
  return () => appConfig.load();
}
export const BACKBONE_URL = environment.API_URL;
export const PAGE_RESULT_SIZE = 10;

/*
 *| AZURE IDS RELATED TO OAUTH
 *| AZURE OAUTH RELATED APP IS CREATED FROM MY ACCOUNT mms.sikandar@outlook.com
 *| LATER WE CAN CREATE A NEW ACCOUNT
 */

//THIS USED TO POINT TO OLD APP - PrimeCommunicaiton-Staging
//export const AZURE_CLIENT_ID = 'a46217e3-e51f-49fb-844e-97f14af89dd5';
//export const AZURE_TENANT_ID = 'b06b830c-5995-4028-aaad-837fb3a6e03a';
//export const AZURE_OBJECT_ID = '5ffedd1b-1d08-41d6-9405-b4b9fe70bf5f';

//THIS POINTS TO AZURE APP (Azure website > Top left menu > Active Directory > App Registation ) - PrimeCommunicaiton-Production
export const AZURE_CLIENT_ID = 'ed41cffa-5a4f-4f89-85a5-66d60115e1ff';
export const AZURE_TENANT_ID = 'b06b830c-5995-4028-aaad-837fb3a6e03a';
export const AZURE_OBJECT_ID = '6aeb14cd-8336-4b9a-8021-58eacda56b22';

export const AZURE_REDIRECT_URL = 'http%3A%2F%2Flocalhost%3A4200%2Fazureoauthresponse';

export const AZURE_OAUTH_URL = `https://login.microsoftonline.com/common/oauth2/authorize?client_id=${AZURE_CLIENT_ID}&redirect_uri=${AZURE_REDIRECT_URL}&resource=https%3A%2F%2Fmanagement.core.windows.net%2F&response_type=code%20id_token&scope=openid%20profile&response_mode=form_post&nonce=637437323903540975.MTAwMWNjNzctOGI5Mi00YWRlLTg1MGQtMDY2MmQyYjUyZjQzYmMyMGQ2MDYtMzhiYS00ZjlhLWI3NWEtMDg2ZTBjNmI1ZWJl&state=CfDJ8L01Reg3wNlAheFjqWIQH3Jpf2xrDtDNK8OnbZCWulh61sg1OjuiTaiVXSSTkOPVJsV-sQ4B1t3cljnqROa7NrufiP0IrvdBUXXxUuutMmFMDOFYo99CT3rQyoyRlA5SfoajKWSij3Rx46WLX9_KJctvf0_GpmodfD2baPjjXz-jjbQdd25G5l4_ueZ3xnI23TH7ld-T6pw0w_AgzQYP_lgm0b4TBGEYJ-dkOKQzpa6DeofnQqSw32qXilMLgQWDH3M5ko1Sxh6RoK3gFG2kul0hjoSewWZ3s5GoF73sZWSWgBk3tlFrArh5hkxrkCNZZgNhLuzcDkoNeEGycW_O4JeDWvPj5mb3kofZ2ZdsYPF6jZ3pLFXr5d_zvO-qMPuqTbZQfTVyF60AC0Ory0BBwi_XKhtZzhuYq671do3BG87AwB0H1Xr8adG14aGGfnXXeIbL1gUn-30iE2BZCW1hYg0&x-client-SKU=ID_NET&x-client-ver=2.1.4.0`;

export const AZURE_API_VERSION = '2017-04-01';
export const DEFAULT_AZURE_POLICY_NAME = "RootManageSharedAccessKey";

export const ALLOWED_MAXIMUM_ENDPOINTS_PER_NAMESPACE = 50;


/*
*| SUPPORTED BROWSERS
*/

//IS INTERNET EXPLORER
export const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

// Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;

export const LOADER_CONFIG: NgxUiLoaderConfig =
{
  "bgsColor": "#5b963e",
  "bgsOpacity": 0.9,
  "bgsPosition": "center-center",
  "bgsSize": 75,
  "bgsType": "circle",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": false,
  "fgsColor": "#5b963e",
  "fgsPosition": "center-center",
  "fgsSize": 75,
  "fgsType": "circle",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 42,
  "logoUrl": "assets/applogo.png",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40,40,40,0.5)",
  "pbColor": "red",
  "pbDirection": "ltr",
  "pbThickness": 2,
  "hasProgressBar": false,
  "text": "Loading...",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
}
